<p>update-pricelists works!</p>
